import ProgressStepper from "components/Common/Stepper/Stepper.tsx";
import { PageHeader } from "features/MarketingMaterials/pages/components/PageHeader/PageHeader.tsx";
import { CheckoutContainer, CheckoutHeaderItem } from "features/MarketingMaterials/pages/Checkout/Checkout.styles.ts";
import {
	PlaceOrderButton,
	ReviewCartPageContent
} from "features/MarketingMaterials/pages/Checkout/ReviewCartPage.styles.ts";
import useMarketingMaterialsCart from "features/MarketingMaterials/hooks/useMarketingMaterialsCart.ts";
import { ReviewCartDetails } from "features/MarketingMaterials/pages/Checkout/components/ReviewCartDetails/ReviewCartDetails.tsx";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { marketingMaterialsCartActions } from "features/reducers/marketingMaterials/cart.ts";
import { useSubmitShoppingCartOrderMutation } from "features/MarketingMaterials/api/merchProductsApi.ts";
import InfoBanner from "components/Common/InfoBanner/InfoBanner.tsx";
import { SubmitShoppingCartRequest } from "features/MarketingMaterials/api/shoppingCart.ts";

export const ReviewCartPage = () => {
	const { cartData, shippingDetails, selectedMerchAccount, validationInfoMessages, validation } =
		useMarketingMaterialsCart();
	console.log(validation);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [submitCart] = useSubmitShoppingCartOrderMutation();

	const handlePlaceOrder = async () => {
		dispatch(marketingMaterialsCartActions.setConfirmationNumber(null));
		const accountId = selectedMerchAccount?.accountId;
		const billToId = selectedMerchAccount?.billTos?.[0]?.billToId;
		if (!accountId || !billToId) {
			navigate("/marketing-materials/view-cart");
			return;
		}

		try {
			const request = {
				poNumber: shippingDetails?.poNumber,
				jobName: shippingDetails?.jobName,
				address: shippingDetails?.address,
				accountId,
				billToId
			} as SubmitShoppingCartRequest;
			const confirmationNumber = await submitCart(request).unwrap();

			if (!confirmationNumber) {
				navigate("/marketing-materials/view-cart");
				return;
			}

			dispatch(marketingMaterialsCartActions.setConfirmationNumber(confirmationNumber));
			navigate("/marketing-materials/confirmation");
		} catch {
			navigate("/marketing-materials/view-cart");
		}
	};

	const getBackorderBanner = () => {
		if (!validationInfoMessages.length) {
			return null;
		}

		return (
			<InfoBanner
				title="Some items are on backorder"
				bodyNode={
					<div>
						<p>
							You can still order these items, but they will ship separately and will be delayed until
							they are back in stock.
						</p>
						<ul>
							{validationInfoMessages.map((errorMessage) => (
								<li key={errorMessage}>{errorMessage}</li>
							))}
						</ul>
					</div>
				}
			/>
		);
	};

	return (
		<>
			<PageHeader cartData={cartData} />
			<CheckoutContainer>
				<CheckoutHeaderItem>
					<h3>Checkout</h3>
					<ProgressStepper data-testid="marketing-materials-header-stepper" />
				</CheckoutHeaderItem>
				{getBackorderBanner()}
				<CheckoutHeaderItem>
					<h4>Review and Place Order</h4>
				</CheckoutHeaderItem>
				<ReviewCartPageContent>
					<ReviewCartDetails cartItems={cartData.cartItems} />
					<div>
						<PlaceOrderButton
							variant="contained"
							onClick={handlePlaceOrder}
						>
							Place Order
						</PlaceOrderButton>
					</div>
				</ReviewCartPageContent>
			</CheckoutContainer>
		</>
	);
};
